import Axios from 'axios';
import MaterialTable from 'material-table';
import React, {useEffect, useState} from 'react';
import {tableIcons} from '../../styles/tableIcons';
import {tableLocalization} from '../../styles/tableLocalization';
import TableTitle from '../utils/TableTitle';

export function AdminTeachersTable() {
  const [teachers, setTeachers] = useState([]);

  useEffect(() => {
    const getTeachers = async () => {
      const result = await Axios.get('/api/user/teachers');

      setTeachers(result.data);
    };
    getTeachers();
  }, []);

  const columns = [
    {title: 'Email', field: 'email'},
    {title: 'Sponsor', field: 'sponsor', emptyValue: '—'},
    {title: 'Students', field: 'studentCount', type: 'numeric'},
    {
      title: 'Last Active',
      field: 'lastActive',
      type: 'datetime',
      defaultSort: 'desc',
    },
  ];

  return (
    <div style={{maxWidth: '100%'}}>
      <MaterialTable
        localization={tableLocalization}
        options={{draggable: false}}
        title={<TableTitle>{'STEMhero Teachers'}</TableTitle>}
        columns={columns}
        data={teachers}
        icons={tableIcons}
      />
    </div>
  );
}
